import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
  Tab,
  Tabs,
} from "@mui/material";
import TabPanel from "./tab-panel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import {
  criticalEmsList,
  checkGrid,
  criticalLoad,
  airConLoad,
  emsDetailTabsArr,
} from "../../utility/defined-methods";
import React, { useState } from "react";
import EmsGrid, { EmsGridID } from "./ems-grid";
import { setEMSName } from "../../datastore/emslistSlice";
import { setEMSID } from "../../datastore/actions";
import EMSInfo from "./emsinfo";
import EMSReport from "./ems-report";
import ComCon from "./com-con";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import Avatar from "@mui/material/Avatar";
import { deepOrange, deepPurple } from "@mui/material/colors";
import ChartTabs from "./tab-charts";
import ChartCategory from "./chart-category";

export const EMSDetailHandler = ({ data }) => {
  let { emsName,eachEMSData  } = data;
  var time = new Date().getTime(); // get your number
  var date = new Date(time); // create Date object
 
  let lastUpdate = Object.keys(eachEMSData).length==0 ? " " : "Last Update: " + date.toString().split(" ")[4] 
  const [value, setValue] = useState(0);
  const _cardInfo = ()=>{

    return (
      <Card>
        <CardHeader
          avatar={
            <Avatar sx={{ bgcolor: deepOrange[500] }}>
              <AccessTimeOutlinedIcon  />
            </Avatar>
          }
          title={emsName === "#" ? "Select EMS from List" : `PowerCell | ${emsName}`}
          subheader={emsName === "#" ? "" : lastUpdate}
          titleTypographyProps={{ variant: "h5" }}
        ></CardHeader>
        <Divider />
        <CardContent>
        
          <Grid
            container
            style={{ marginTop: "25px", maxHeight: "80vh", overflow: "auto", padding: "10px", margin: "10px" }}
          >
            <Grid item xs={6}>
              <Box sx={{ borderBottom: 1, borderColor: "divider", padding: "10px", margin: "10px" }}>
                <Tabs
                  indicatorColor="secondary"
                  textColor="inherit"
                  value={value}
                  onChange={(e, val) => {
                    setValue(val);
                  }}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: 'darkgreen',
                    },
                  }}
                  sx={{
                    '& .Mui-selected': {
                      backgroundColor: 'lightgreen',
                    },
                  }}
                >
                  {emsDetailTabsArr.map((link, index) => {
                    return <Tab key={index} label={link}></Tab>;
                  })}
                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <EMSInfo />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Box sx={{ borderBottom: 1, borderColor: "divider", padding: "5px", margin: "5px" }}>
                  <ChartCategory/>
                </Box>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <ComCon />
              </TabPanel>
              <TabPanel value={value} index={3}>
                <EMSReport />
              </TabPanel>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
  return emsName === '#' ? (
    <Grid 
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ 
        minHeight: '80vh',
        width: '100%',
        padding: '20px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #ddd',
        borderRadius: '4px',
        margin: '10px'
      }}
    >
      <Grid item>
        <Card>
          <CardHeader
            avatar={
              <Avatar sx={{ bgcolor: deepOrange[500] }}>
                <AccessTimeOutlinedIcon />
              </Avatar>
            }
            title="Select EMS from List"
            titleTypographyProps={{ 
              variant: "h5",
              align: "center",
              style: { color: '#666' }
            }}
          />
        </Card>
      </Grid>
    </Grid>
  ) : _cardInfo();
};

export const HandleEmsGrid = ( _map, userID, currentSocket, dispatch) => {
 console.log("Maps",_map)
  return (
    <Grid container spacing={3}>
      {Array.from(_map).map((element) => {

        let { packet, id } = element[1];
          let _emsGridData = {
            emsID: element[0].split("_")[2],
          };
          // setColorDecide(!colorDecide);
          return (
            <EmsGridID
              key={id}
              emsGridData={_emsGridData}
              userID={userID}
              socket={currentSocket}
              dispatch={dispatch}
            />
          );
        
      })}
    </Grid>
  );
  // return <div></div>;
};
export const HandleEmsGridID = (user,_map, userID, currentSocket, dispatch) => {
  console.log("Maps",_map)
  return (
    <Grid container spacing={3}>
     {Array.from(_map).map((element) => {

        let { packet, id } = element[1];
        if (packet["BatteryID"] !== undefined) {
          let _emsGridData = {
            emsID: element[0].split("_")[2],
            checkGrid: checkGrid({
              recVoltA: packet["Rec"]["Volt"]["A"],
              recVoltB: packet["Rec"]["Volt"]["B"],
              recVoltC: packet["Rec"]["Volt"]["C"],
            })
              ? "OFF"
              : "ON",
            emsType: criticalEmsList.includes(element[0].split("_")[2])
              ? "Critical"
              : "Air Con",
            emsSOC: packet["Shunt"]["SOC"],
            emsHealth: packet["BatteryHealth"] < 90 ? "Normal" : "Good",
            emsLoad: criticalEmsList.includes(element[0].split("_")[2])
              ? criticalLoad(packet)
              : airConLoad(packet),
          };
          // setColorDecide(!colorDecide);
          return (
            <EmsGridID
              key={id}
              emsGridData={_emsGridData}
              userID={userID}
              socket={currentSocket}
              dispatch={dispatch}
            />
          );
        }
      })}
    </Grid>
  );
  // return <div></div>;
};
